import _ from 'lodash';
import { TWISTED } from './const';
import { dbget, dbdel, dbset } from '../HOME/utils';

export function selectorClass(x, y) {
  return `mt-page simple-selector${x < y ? '' : ' simple-selector-landscape'}`;
}

export function canSurrender(props) {
  const board = props.board.current ? props.board.current : null;
  return board;
}

const baseKey = props => {
  const { mode, size } = props;
  return `MT • ${mode.slice(0, 1)}${size} • `;
};

export function boardKey(props) {
  return `${baseKey(props)}BOARD`;
}

export function statsKey(props) {
  return `${baseKey(props)}STATS`;
}

export function getStats(props, resolve) {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
}

export function getMoreStats(stats, size, mode, msecs) {
  let { plays, aggScore, aveScore, bestScore } = stats || {};

  if (!aveScore) {
    aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);
  }

  const score = calcScore(msecs || 0, size, mode);
  const grade = _.round(((aveScore || 0) * Math.min(10, plays || 0)) / 10.0);
  return { plays, aveScore, bestScore, grade, score };
}

export function setStats(props, msecs, surrender) {
  dbdel(boardKey(props));

  let { stats, mode, size } = props;
  let { plays, aggScore, bestScore } = stats || {};

  plays += 1;
  msecs = msecs || 0;
  let score = 0;

  if (surrender) {
    msecs = Math.max(msecs, maxSecs(size, mode) * 1000);
  } else {
    score = calcScore(msecs, size, mode);

    if (score === 1000) {
      score = 0;
    }
  }

  aggScore = (aggScore || 0) + score;

  bestScore = Math.max(score, bestScore || 0);

  const key = statsKey(props);
  stats = { plays, aggScore, bestScore };

  dbset(key, stats);
  props.updateStats(stats);
}

const calcScore = (msecs, size, mode) => {
  const max = maxSecs(size, mode);
  const score = _.round((1000 * max - msecs) / max);
  return Math.max(score, 10);
};

const maxSecs = (size, mode) => {
  const i = size - 3;
  return mode === TWISTED ? [18, 90, 300, 1000, 2000][i] : [12, 60, 200, 550, 900][i];
};

export const sizeName = size => {
  switch (size) {
    case 3:
      return 'XS';
    case 4:
      return 'S';
    case 5:
      return 'M';
    case 6:
      return 'L';
    case 7:
      return 'XL';
    default:
      break;
  }
};
